(function(){
  if(window.__idgHome) return; window.__idgHome = 1;
  var DESIGN = !!(window.Shopify && Shopify.designMode);

  function initReveal(scope){
    var els = (scope||document).querySelectorAll('.idg-reveal:not([data-idgr])');
    if(!els.length) return;
    if(DESIGN || !window.IntersectionObserver){
      els.forEach(function(e){e.setAttribute('data-idgr','1');e.classList.add('idg-on')});
      return;
    }
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('idg-on')})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){el.setAttribute('data-idgr','1');io.observe(el)});
  }

  function initModes(root){
    if(!root || root.getAttribute('data-idg-init')) return;
    root.setAttribute('data-idg-init','1');

    var DUR=9000, DRAW=2600;
    var tabWrap=root.querySelector('.idg-mtabs'),
        stage=root.querySelector('.idg-mstage'),
        tabs=root.querySelectorAll('.idg-mtab'),
        vids=root.querySelectorAll('.idg-mstv'),
        panels=root.querySelectorAll('.idg-mpanel'),
        loads=root.querySelector('.idg-mloads'),
        phase=root.querySelector('.idg-mphase'),
        cap=root.querySelector('.idg-mcap'),
        path=root.querySelector('.idg-mpath'),
        dot=root.querySelector('.idg-mdot'),
        midx=root.querySelector('.idg-midx'),
        rig=root.querySelector('.idg-mrig'),
        rigPl=rig?rig.querySelectorAll('.idg-mrig-plates b'):[],
        rigCable=rig?rig.querySelector('.idg-mrig-cable'):null,
        rigPips=rig?rig.querySelectorAll('.idg-mrig-pips i'):[];
    if(!tabWrap||!stage||!panels.length)return;
    var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var cur=-1,timer=null,cyc=null,inview=false,hover=false;
    /* ---- weight-stack rig engine v2 · 配重块 · 连续时间轴 rAF（无分段停顿） ----
       每模式一条连续 timeline: seg[{a,b 毫秒窗, y0->y1 行程(缓动 e), m: 时刻标记{f,K,ld,ph}}]
       每帧从时钟重解算状态: 位移/挂片/力值/相位/节拍/抖动 全部同源, 不会漂移不会顿挫 */
    var RIGTL=[
      /* 01 Standard — 同重上下, 纯余弦呼吸 */
      {dur:3930,pips:0,seg:[
        {a:0,b:1600,y0:0,y1:1,e:'cos',mv:1,m:[{f:0,K:5,ld:0,ph:0}]},
        {a:1600,b:1880,y:1},
        {a:1880,b:3480,y0:1,y1:0,e:'cos',mv:1,m:[{f:0,K:5,ld:0,ph:1}]},
        {a:3480,b:3930,y:0}]},
      /* 02 Eccentric — 轻上4片; 顶端咔哒+3; 重降(慢) */
      {dur:4800,pips:0,seg:[
        {a:0,b:1450,y0:0,y1:1,e:'cos',mv:1,m:[{f:0,K:4,ld:0,ph:0}]},
        {a:1450,b:1900,y:1,m:[{f:.14,K:7,ld:1,ph:1}]},
        {a:1900,b:4300,y0:1,y1:0,e:'cosS',mv:1},
        {a:4300,b:4800,y:0,m:[{f:.3,K:4,ld:0,ph:0}]}]},
      /* 03 Spring — 单段连续上行(越高越重减速), 行程中渐进挂片 */
      {dur:5000,pips:0,seg:[
        {a:0,b:2600,y0:0,y1:1,e:'outq',mv:1,m:[{f:0,K:2,ld:0,ph:0},{f:.21,K:4,ld:1,ph:1},{f:.47,K:6,ld:2,ph:2}]},
        {a:2600,b:2900,y:1},
        {a:2900,b:4600,y0:1,y1:0,e:'cos',mv:1,m:[{f:.35,K:4,ld:1,ph:1},{f:.7,K:2,ld:0,ph:0}]},
        {a:4600,b:5000,y:0}]},
      /* 04 Isokinetic — 全程线性匀速, 行进中挂片波动, 节拍恒定 */
      {dur:6240,pips:1,seg:[
        {a:0,b:2850,y0:0,y1:1,e:'lin',mv:1,m:[{f:0,K:4,ld:0,ph:0},{f:.34,K:6,ld:1,ph:1},{f:.67,K:5,ld:2,ph:2}]},
        {a:2850,b:3090,y:1},
        {a:3090,b:5940,y0:1,y1:0,e:'lin',mv:1,m:[{f:0,K:4,ld:0,ph:0}]},
        {a:5940,b:6240,y:0}]}
    ];
    var rigRAF=null,rigMode=-1,rigT0=0,rigPrevK=-1,rigLastLd=-1,rigLastPh=-1,rigLastJit=0,rigLastY=0,
        rigPH=[],rigBlend={},PIPMS=190,GEO={step:11.8,travel:40,top:8};
    function rigEase(e,f){
      if(e==='lin')return f;
      if(e==='outq')return 1-(1-f)*(1-f);
      if(e==='cosS')return f<.5?2*f*f:1-Math.pow(-2*f+2,2)/2;
      return (1-Math.cos(Math.PI*f))/2;
    }
    function rigGeo(){
      if(!rig)return;
      var h=rig.getBoundingClientRect().height||148;
      GEO.travel=Math.round(h*.27);
      GEO.top=Math.max(6,Math.round(h*.05));
      GEO.step=(h-GEO.travel-GEO.top-12)/(rigPl.length-1||7);
    }
    function rigRest(i){return GEO.top+GEO.travel+i*GEO.step}
    function setLoad(k){
      if(!loads)return;
      var bs=loads.querySelectorAll('b');
      for(var i=0;i<bs.length;i++)bs[i].classList.toggle('idg-on',i===k);
    }
    function rigStop(){
      if(rigRAF){cancelAnimationFrame(rigRAF);rigRAF=null}
      rigMode=-1;
      for(var i=0;i<rigPips.length;i++)rigPips[i].classList.remove('idg-lit');
      if(loads){var b=loads.querySelector('b.idg-on');
        if(b&&b.firstChild&&b.firstChild.nodeType===3&&b.getAttribute('data-v'))b.firstChild.nodeValue=b.getAttribute('data-v')}
    }
    function rigResolve(tl,t){
      var K=null,ld=null,ph=null,y=0,mv=0,i,j,s,m;
      for(i=0;i<tl.seg.length;i++){s=tl.seg[i];
        if(t>=s.a){
          var sf=(Math.min(t,s.b)-s.a)/(s.b-s.a);
          if(s.m)for(j=0;j<s.m.length;j++){m=s.m[j];if(sf>=m.f){if(m.K!=null)K=m.K;if(m.ld!=null)ld=m.ld;if(m.ph!=null)ph=m.ph}}
          if(t<s.b){y=(s.y0!=null)?(s.y0+(s.y1-s.y0)*rigEase(s.e,sf)):(s.y!=null?s.y:y);mv=s.mv?1:0}
          else{y=(s.y1!=null)?s.y1:(s.y!=null?s.y:y)}
        }
      }
      return {y:y,mv:mv,K:K==null?4:K,ld:ld,ph:ph};
    }
    function rigFrame(ts){
      if(rigMode<0)return;
      var tl=RIGTL[rigMode],t=(ts-rigT0)%tl.dur,st=rigResolve(tl,t),i;
      if(st.K!==rigPrevK){
        for(i=0;i<rigPl.length;i++){
          var eng=i<st.K,was=i<rigPrevK;
          if(eng!==was&&rigPrevK>=0){
            rigBlend[i]={t0:ts,from:was?rigRest(i)-GEO.travel*rigLastY:rigRest(i)};
            if(eng){rigPl[i].classList.remove('idg-join');void rigPl[i].offsetWidth;rigPl[i].classList.add('idg-join')}
          }
          rigPl[i].classList.toggle('idg-eng',eng);
          rigPl[i].classList.toggle('idg-pin',i===st.K-1);
        }
        rigPrevK=st.K;
      }
      rigLastY=st.y;
      for(i=0;i<rigPl.length;i++){
        var tgt=rigRest(i)-(i<rigPrevK?GEO.travel*st.y:0),yv=tgt,bl=rigBlend[i];
        if(bl){var bf=(ts-bl.t0)/240;
          if(bf>=1)delete rigBlend[i];
          else{bf=1-(1-bf)*(1-bf);yv=bl.from+(tgt-bl.from)*bf}}
        rigPl[i].style.transform='translate3d(0,'+yv.toFixed(2)+'px,0)';
      }
      if(rigCable)rigCable.style.height=Math.max(4,rigRest(0)-GEO.travel*st.y).toFixed(1)+'px';
      if(st.ld!=null&&st.ld!==rigLastLd){rigLastLd=st.ld;setLoad(st.ld)}
      if(st.ph!=null&&st.ph!==rigLastPh&&phase){rigLastPh=st.ph;phase.textContent=rigPH[st.ph]||''}
      if(tl.pips){
        if(st.mv){var lit=Math.floor((ts-rigT0)/PIPMS)%rigPips.length;
          for(i=0;i<rigPips.length;i++)rigPips[i].classList.toggle('idg-lit',i===lit)}
        else for(i=0;i<rigPips.length;i++)rigPips[i].classList.remove('idg-lit');
      }
      if(ts-rigLastJit>430){rigLastJit=ts;
        var b=loads?loads.querySelector('b.idg-on'):null;
        if(b&&b.firstChild&&b.firstChild.nodeType===3){
          var v=parseInt(b.getAttribute('data-v')||'0',10);
          if(v)b.firstChild.nodeValue=st.mv?String(v+((Math.random()<.5?-1:1)*(Math.random()<.72?1:2))):String(v)}}
      rigRAF=requestAnimationFrame(rigFrame);
    }
    function rigRun(mode){
      rigStop();
      if(!rig)return;
      rig.classList.toggle('idg-iso',mode===3);
      rigGeo();
      rigPH=(panels[mode]?panels[mode].getAttribute('data-phases'):'').split(';');
      rigPrevK=-1;rigLastLd=-1;rigLastPh=-1;rigLastJit=0;rigLastY=0;rigBlend={};
      for(var i=0;i<rigPl.length;i++)rigPl[i].style.transition='none';
      if(RM){
        var Ks=[5,7,6,5][mode]||5;
        for(var j=0;j<rigPl.length;j++){
          rigPl[j].classList.toggle('idg-eng',j<Ks);
          rigPl[j].classList.toggle('idg-pin',j===Ks-1);
          rigPl[j].style.transform='translate3d(0,'+(rigRest(j)-(j<Ks?GEO.travel*.55:0))+'px,0)';
        }
        if(rigCable)rigCable.style.height=Math.max(4,rigRest(0)-GEO.travel*.55)+'px';
        setLoad(0);
        return;
      }
      rigMode=mode;
      rigT0=(window.performance&&performance.now)?performance.now():0;
      rigFrame(rigT0); /* 同步先画第 0 帧（rAF 被节流时也有正确姿态），后续帧由 rigFrame 自续 */
    }
    function now(){return (window.performance&&performance.now)?performance.now():new Date().getTime()}
    function stop(){if(timer){clearInterval(timer);timer=null}}
    function start(){stop();if(RM)return;timer=setInterval(function(){show((cur+1)%panels.length)},DUR)}
    function restartFill(){var t=tabs[cur];if(!t)return;t.style.animation='none';void t.offsetHeight;t.style.animation=''}
    function play(v){if(!v)return;try{var p=v.play();if(p&&p['catch'])p['catch'](function(){})}catch(e){}}
    function show(i){
      if(i===cur||!panels[i])return; cur=i;
      var p=panels[i], j;
      for(j=0;j<tabs.length;j++){tabs[j].classList.toggle('idg-on',j===i);tabs[j].setAttribute('aria-selected',j===i?'true':'false')}
      restartFill();
      for(j=0;j<vids.length;j++){
        if(j===i){vids[j].classList.add('idg-on');try{vids[j].currentTime=0}catch(e){}play(vids[j])}
        else{vids[j].classList.remove('idg-on');try{vids[j].pause()}catch(e){}}
      }
      for(j=0;j<panels.length;j++)panels[j].classList.toggle('idg-on',j===i);
      stage.classList.remove('idg-shift');void stage.offsetWidth;stage.classList.add('idg-shift');
      if(midx)midx.textContent=p.getAttribute('data-n')||'';
      var LD=(p.getAttribute('data-loads')||'').split(';'),
          PH=(p.getAttribute('data-phases')||'').split(';'),h='';
      for(j=0;j<LD.length;j++){var f=LD[j].split(',');if(!f[0])continue;
        h+='<b data-v="'+f[0]+'" class="'+(f[2]==='1'?'idg-hi':'')+(j===0?' idg-on':'')+'">'+f[0]+'<i>'+(f[1]||'')+'</i></b>'}
      if(loads)loads.innerHTML=h;
      if(phase)phase.textContent=PH[0]||'';
      if(cap)cap.textContent=p.getAttribute('data-cap')||'';
      if(path&&dot){
        path.setAttribute('d',p.getAttribute('data-path')||'M0,32 L260,32');
        var len=400; try{len=path.getTotalLength()}catch(e){}
        path.style.setProperty('--idg-len',len);
        path.classList.remove('idg-run');dot.classList.remove('idg-run');void path.getBoundingClientRect();
        path.classList.add('idg-run');dot.classList.add('idg-run');
        var t0=now();
        var tick=function(){
          if(cur!==i)return;
          var t=Math.min(1,(now()-t0)/DRAW), e=t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;
          try{var pt=path.getPointAtLength(len*e);dot.setAttribute('cx',pt.x);dot.setAttribute('cy',pt.y)}catch(err){}
          if(t<1&&window.requestAnimationFrame)requestAnimationFrame(tick);
        };
        if(RM){try{var pe=path.getPointAtLength(len);dot.setAttribute('cx',pe.x);dot.setAttribute('cy',pe.y)}catch(e){}}
        else if(window.requestAnimationFrame)requestAnimationFrame(tick);
      }
      if(cyc){clearInterval(cyc);cyc=null}
      if(!rig&&LD.length>1&&!RM){
        var s=0;
        cyc=setInterval(function(){
          if(cur!==i){clearInterval(cyc);cyc=null;return}
          s=(s+1)%LD.length;
          var bs=loads?loads.querySelectorAll('b'):[];
          for(var k=0;k<bs.length;k++)bs[k].classList.toggle('idg-on',k===s);
          if(phase)phase.textContent=PH[Math.min(s,PH.length-1)]||'';
        },900);
      }
      if(rig)rigRun(i);
    }
    tabWrap.addEventListener('click',function(e){
      var b=e.target&&e.target.closest?e.target.closest('.idg-mtab'):null;
      if(!b)return; show(parseInt(b.getAttribute('data-i'),10)||0); if(inview&&!hover)start();
    });
    tabWrap.addEventListener('keydown',function(e){
      var n=null;
      if(e.key==='ArrowRight')n=(cur+1)%panels.length;
      if(e.key==='ArrowLeft')n=(cur-1+panels.length)%panels.length;
      if(n===null)return; e.preventDefault(); show(n); if(tabs[n])tabs[n].focus(); if(inview&&!hover)start();
    });
    stage.addEventListener('mouseenter',function(){hover=true;stop();tabWrap.classList.add('idg-paused')});
    stage.addEventListener('mouseleave',function(){hover=false;tabWrap.classList.remove('idg-paused');restartFill();if(inview)start()});
    /* preload 预热（2026-08-20 店主授权）
       四支模式视频原本写死 preload="auto"，首屏无条件急下载（压缩前约 2.5MB，
       压缩后仍近 1.2MB），而这个板块在首页远低于首屏。已改成 preload="none"，
       改由本 IO 在【板块进视口那一刻】才预热：用户滚到这里时视频已就绪，
       切 Tab 不会卡；用户不滚到这里就一个字节都不下。
       reduced-motion 下不预热——那种偏好本来就不放动效，下了也是白下。 */
    var warmed=false;
    function warm(){
      if(warmed||RM)return; warmed=true;
      for(var w=0;w<vids.length;w++){try{vids[w].preload='auto';vids[w].load()}catch(e){}}
    }
    if(window.IntersectionObserver){
      new IntersectionObserver(function(en){
        inview=en[0].isIntersecting;
        if(inview){warm();if(!hover)start();play(vids[cur<0?0:cur]);if(rig&&cur>=0&&!rigRAF&&!RM)rigRun(cur)}
        else{stop();rigStop();for(var j=0;j<vids.length;j++){try{vids[j].pause()}catch(e){}}}
      },{threshold:.2}).observe(root);
    }else{inview=true;warm();start()}
    show(0);
  }

  function initFilm(scope){
    var fv=(scope||document).querySelector('.idg-film-frame video:not([data-idgf])'); if(!fv)return;
    fv.setAttribute('data-idgf','1');

    function go(){var p=fv.play();if(p&&p['catch'])p['catch'](function(){})}
    if(window.IntersectionObserver){
      new IntersectionObserver(function(en){
        if(en[0].isIntersecting)go(); else{try{fv.pause()}catch(e){}}
      },{threshold:.25}).observe(fv);
    }else go();
  }

  /* FOLD · 视频舞台（2026-08-22 重做）
     旧版是滚动 scrub，依赖 .idg-fold-track；板块简化后那个元素没了，
     initFold 一直 early-return，带 data-src 的 video 永远没被赋 src ——
     线上折叠板块其实一帧视频都没播过。这版换成：
     进视口才下载 + 播放，出视口即停（动效铁律）；
     prefers-reduced-motion 完全不播，只留 poster 静帧；
     视频资产已做接缝交叉溶解（末尾 0.8s 溶进片头，首尾帧相接），可以安全 loop；
     板块设置默认勾选循环（输出 data-loop="1"），关掉则播完停在终帧。 */
  function initFold(scope){
    var sc=scope||document;
    var sec=(sc.id==='idg-fold')?sc:(sc.querySelector&&sc.querySelector('#idg-fold'));
    if(!sec||sec.getAttribute('data-idgfold'))return;
    var v=sec.querySelector('.idg-fold-video');
    if(!v)return;
    sec.setAttribute('data-idgfold','1');
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(v.getAttribute('data-loop')==='1')v.loop=true;
    var stage=sec.querySelector('.idg-fold-stage')||sec, loaded=false;
    function load(){
      if(loaded)return; loaded=true;
      var s=v.getAttribute('data-src');
      if(s&&!v.currentSrc){v.src=s;try{v.load()}catch(e){}}
    }
    function play(){
      load();
      if(!v.loop&&v.ended){try{v.currentTime=0}catch(e){}}
      var pr=v.play(); if(pr&&pr['catch'])pr['catch'](function(){});
    }
    function pause(){try{v.pause()}catch(e){}}
    if(window.IntersectionObserver){
      new IntersectionObserver(function(en){
        if(en[0].isIntersecting)play(); else pause();
      },{threshold:.25}).observe(stage);
    }else{play()}
  }

  function initLib(scope){
    var sc=scope||document;
    if(!sc.querySelector('.idg-lib-tab:not([data-idgl])'))return;
    sc.querySelectorAll('.idg-lib-tab').forEach(function(b){b.setAttribute('data-idgl','1')});
sc.querySelectorAll('.idg-lib-tab').forEach(function(b){b.addEventListener('click',function(){
    var section=b.closest('.idg-sec')||sc;
    section.querySelectorAll('.idg-lib-tab').forEach(function(x){x.classList.remove('idg-on')});
    b.classList.add('idg-on');
    var f=b.getAttribute('data-f');
    section.querySelectorAll('.idg-mv').forEach(function(m){
      var show = (f==='all') || (m.getAttribute('data-c')===f);
      m.classList.toggle('idg-hide', !show);
      if(show){var v=m.querySelector('video'); if(v&&v.play) v.play().catch(function(){});}
    });
    var grid=section.querySelector('.idg-lib-grid');
    if(grid)grid.scrollLeft=0;
  })});
    sc.querySelectorAll('[data-lib-shift]').forEach(function(b){
      if(b.hasAttribute('data-idgl'))return;
      b.setAttribute('data-idgl','1');
      b.addEventListener('click',function(){
        var section=b.closest('.idg-sec')||sc;
        var grid=section.querySelector('.idg-lib-grid');
        if(!grid)return;
        var dir=parseInt(b.getAttribute('data-lib-shift'),10)||1;
        grid.scrollBy({left:dir*Math.max(grid.clientWidth*.72,260),behavior:'smooth'});
      });
    });
  }

  function initSell(scope){
    var q=(scope&&scope.querySelectorAll)?scope:document;
    var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    q.querySelectorAll('.idg-os-fig video:not([data-idgos]), .idg-frame video:not([data-idgos])').forEach(function(v){
      v.setAttribute('data-idgos','1');
      if(RM){try{v.pause()}catch(e){} return;}
      var go=function(){var p=v.play(); if(p&&p['catch'])p['catch'](function(){});};
      if(DESIGN||!window.IntersectionObserver){go();return;}
      new IntersectionObserver(function(en){ if(en[0].isIntersecting){go();} else {try{v.pause()}catch(e){}} },{threshold:.25}).observe(v);
    });
    q.querySelectorAll('.idg-os-hud:not([data-idgos])').forEach(function(hud){
      hud.setAttribute('data-idgos','1');
      var ns=hud.querySelectorAll('.idg-os-hud-n'); var bars=hud.querySelectorAll('.idg-os-hud-bar span');
      var fig=hud.parentNode; var vid=fig?fig.querySelector('video'):null;
      var prog=1; var raf=null; var armed=false; var live=false; var lraf=null; var atPeak=false;
      var render=function(){ var u=hud.getAttribute('data-unit')||'kg'; /* EU: 公制默认 kg（US 为 lb） */
        ns.forEach(function(n){ var t=parseInt(n.getAttribute('data-'+u),10)||0; n.textContent=Math.round(t*prog); });
        if(live){ var w=Math.max(0,Math.min(prog,1))*100; bars.forEach(function(b){b.style.width=w+'%';}); } };
      var pop=function(){ hud.classList.remove('idg-hud-done'); void hud.offsetWidth; hud.classList.add('idg-hud-done'); };
      /* 力值曲线: 与 D 段动作循环同步 — 静置低位呼吸 → 上拉冲顶(带回弹) → 顶峰保持 → 缓降 */
      var curve=function(x){
        if(x<0.31){ return 0.16+0.03*Math.sin(x*22); }
        if(x<0.54){ var p=(x-0.31)/0.23; return 0.18+0.82*(1+2.7*Math.pow(p-1,3)+1.7*Math.pow(p-1,2)); }
        if(x<0.62){ return 1; }
        var p2=(x-0.62)/0.38; return 1-0.82*(p2*p2*(3-2*p2));
      };
      var lstep=function(){ lraf=null;
        if(!live||!vid||vid.paused||!vid.duration){return;}
        var x=(vid.currentTime%vid.duration)/vid.duration; var f=curve(x);
        var peak=f>=0.99;
        if(peak&&!atPeak){atPeak=true;pop();}
        if(!peak&&f<0.9){atPeak=false;}
        prog=f; render();
        lraf=requestAnimationFrame(lstep); };
      var startLive=function(){ if(RM||!window.requestAnimationFrame||!vid)return; live=true; hud.classList.add('idg-hud-live'); if(!lraf){lraf=requestAnimationFrame(lstep);} };
      var stopLive=function(){ if(lraf&&window.cancelAnimationFrame){cancelAnimationFrame(lraf);lraf=null;} };
      var count=function(dur,then){ if(raf&&window.cancelAnimationFrame)cancelAnimationFrame(raf); hud.classList.remove('idg-hud-done');
        if(RM||!window.requestAnimationFrame){prog=1;render();hud.classList.add('idg-hud-done');if(then)then();return;}
        var t0=null,c1=0.9,c3=c1+1;
        var step=function(ts){ if(t0===null)t0=ts; var p=(ts-t0)/dur; if(p>1)p=1;
          prog=1+c3*Math.pow(p-1,3)+c1*Math.pow(p-1,2); render();
          if(p<1){raf=requestAnimationFrame(step);}else{prog=1;render();hud.classList.add('idg-hud-done');if(then)then();} };
        raf=requestAnimationFrame(step); };
      var run=function(){ if(armed)return; armed=true; hud.classList.add('idg-hud-on');
        count(1700,function(){ startLive(); }); };
      if(vid){ vid.addEventListener('play',function(){ if(live&&!lraf&&window.requestAnimationFrame){lraf=requestAnimationFrame(lstep);} });
        vid.addEventListener('pause',function(){ stopLive(); if(armed){prog=1;render();} }); }
      /* EU: HUD 无 LBS/KG 切换控件（纯 kg），US 的 .idg-os-hud-u click handler 有意不移植 */
      render();
      if(DESIGN){run();return;}
      if(window.IntersectionObserver){ new IntersectionObserver(function(en){ if(en[0].isIntersecting){run();} },{threshold:.3}).observe(hud); } else { run(); }
    });
  }

  function initTech(scope){
    var els=(scope||document).querySelectorAll('.idg-t2-eq:not([data-idgos2])');
    Array.prototype.forEach.call(els,function(eq){
      eq.setAttribute('data-idgos2','1');
      if(DESIGN||!window.IntersectionObserver){eq.classList.add('idg-live');return;}
      new IntersectionObserver(function(en){en.forEach(function(e){eq.classList.toggle('idg-live',e.isIntersecting)})},{threshold:.2}).observe(eq);
    });
  }

  function initStory(scope){
    var els=(scope||document).querySelectorAll('.idg-manifesto:not([data-idgstory])');
    Array.prototype.forEach.call(els,function(sec){
      sec.setAttribute('data-idgstory','1');
      var film=sec.querySelector('.idg-story-film');
      var btn=sec.querySelector('.idg-story-play');
      if(!film||!btn) return;
      btn.addEventListener('click',function(){
        var src=film.getAttribute('data-embed');
        if(!src||film.classList.contains('idg-live')) return;
        var f=document.createElement('iframe');
        f.setAttribute('src',src);
        f.setAttribute('title',film.getAttribute('data-title')||'Brand film');
        f.setAttribute('allow','autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen','');
        f.setAttribute('frameborder','0');
        film.appendChild(f);
        film.classList.add('idg-live');
      });
    });
  }

  /* X1 STORY RAIL · 吸顶章节导航（2026-08-22 区块化，从 section 内联 script 搬进来）
     搬家原因：导航项改成区块后，编辑器每次增删区块都会 innerHTML 重渲染该 section，
     内联 <script> 在这种注入下不执行 —— 留在原处等于文案团队一改就整条失效。
     同时修掉文燕报的问题：目标板块在页面上不存在时，按钮自动隐藏（此前只是被踢出
     滚动追踪列表，按钮仍留在 DOM 里，点了没反应也删不掉）。 */
  function initRail(scope){
    var sc = scope || document;
    var root = (sc.getAttribute && sc.getAttribute('data-rail-sid')) ? sc : (sc.querySelector && sc.querySelector('[data-idg-story-rail]'));
    if(!root || root.getAttribute('data-railready')) return;
    root.setAttribute('data-railready','1');

    var sid = root.getAttribute('data-rail-sid') || '';
    /* 编辑器重渲染：上一轮 hoist 到 body 的同 id 旧节点要先清掉，否则页面上会叠出两条 */
    var stale = document.querySelectorAll('[data-idg-story-rail][data-rail-sid="' + sid + '"]');
    Array.prototype.forEach.call(stale, function(n){ if(n !== root && n.parentNode) n.parentNode.removeChild(n); });

    var anchor = document.getElementById(root.getAttribute('data-rail-anchor') || '');
    /* 吸顶条必须挂到 body 直属层级：留在 #main-content 里时，后面的整屏板块
       （idg-servo 等 position:relative + overflow:hidden）会把它盖住/裁掉。
       哨兵留在原位负责"该不该出现"的判定。 */
    if(document.body && root.parentNode !== document.body){
      document.body.appendChild(root);
      root.setAttribute('data-hoisted','1');
    }

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-section-key]'));
    var shell = root.querySelector('.idg-sr-shell');
    var finalSection = null;
    var items = [];
    var ticking = false;

    var DIRECT = { hero:'#idg-hero', vs:'[id^="idg-x1-vs-"]', servo:'#idg-servo', modes:'#idg-modes',
                   sell:'#idg-omni-sell', tech:'#idg-tech', assist:'#idg-assist', fold:'#idg-fold',
                   safety:'#idg-safety', dossier:'#idg-omni-specs' };

    function getTarget(link){
      var custom = (link.getAttribute('data-section-custom') || '').trim();
      if(custom){
        var c = custom.charAt(0);
        if(c !== '#' && c !== '.' && c !== '[') custom = '#' + custom;
        try { return document.querySelector(custom); } catch(e){ return null; }
      }
      var key = link.getAttribute('data-section-key') || '';
      if(!key || key === 'custom') return null;
      var direct = DIRECT[key];
      var byWrapper = null;
      try { byWrapper = document.querySelector('[id$="__' + key + '"]'); } catch(e){}
      return byWrapper || (direct ? document.querySelector(direct) : null);
    }

    function rebuild(){
      items = [];
      links.forEach(function(link){
        var t = getTarget(link);
        /* 目标不存在 = 该板块已从页面移除 → 直接把按钮藏掉，不留死链 */
        link.hidden = !t;
        link.style.display = t ? '' : 'none';
        if(t) items.push({ link: link, target: t });
      });
      finalSection = document.querySelector('[id$="__final"], #idg-final') || finalSection;
    }

    function headerBottom(){
      var cands = document.querySelectorAll('header, .header, [id*="__header"]');
      var bottom = 0;
      Array.prototype.forEach.call(cands, function(el){
        var st = window.getComputedStyle(el), r = el.getBoundingClientRect();
        if((st.position === 'fixed' || st.position === 'sticky') && r.height > 20 && r.height < 180 && r.bottom > 0){
          bottom = Math.max(bottom, r.bottom);
        }
      });
      return Math.max(bottom + 10, window.innerWidth < 900 ? 76 : 92);
    }

    function update(){
      ticking = false;
      if(!root.isConnected){ detach(); return; }
      if(!shell) return;
      rebuild();
      var top = headerBottom();
      root.style.setProperty('--rail-top', Math.round(top) + 'px');
      var gate = (anchor && anchor.isConnected) ? anchor : root;
      var trigger = gate.getBoundingClientRect().top <= top + 12;
      var beforeFooter = !finalSection || finalSection.getBoundingClientRect().bottom > top + 80;
      var visible = trigger && beforeFooter && items.length > 0;
      root.classList.toggle('is-visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if(!items.length) return;

      var marker = top + shell.offsetHeight + 38;
      var active = items[0];
      items.forEach(function(it){ if(it.target.getBoundingClientRect().top <= marker) active = it; });
      items.forEach(function(it){
        var on = it === active;
        it.link.classList.toggle('is-active', on);
        if(on) it.link.setAttribute('aria-current','true'); else it.link.removeAttribute('aria-current');
      });
      if(active && window.innerWidth < 900){
        var track = active.link.parentNode;
        if(track){
          var want = active.link.offsetLeft - (track.clientWidth - active.link.offsetWidth) / 2;
          track.scrollTo({ left: Math.max(0, want), behavior: 'auto' });
        }
      }
    }

    function requestUpdate(){ if(ticking) return; ticking = true; window.requestAnimationFrame(update); }
    function onScroll(){ if(!root.isConnected){ detach(); return; } requestUpdate(); }
    function onResize(){ if(!root.isConnected){ detach(); return; } rebuild(); requestUpdate(); }
    function detach(){
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if(root.parentNode) root.parentNode.removeChild(root);
    }

    links.forEach(function(link){
      link.addEventListener('click', function(){
        var t = getTarget(link);
        if(!t) return;
        var offset = headerBottom() + (shell ? shell.offsetHeight : 54) + 16;
        var y = t.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo(0, Math.max(0, y));
        window.setTimeout(requestUpdate, 40);
      });
    });

    rebuild();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('load', function(){ rebuild(); requestUpdate(); }, { once: true });
  }

  /* 注册弹窗 · 专用生命周期、频控、键盘无障碍与埋点。
     共享 modal-dialog 只负责 show/hide；signup 自己负责何时出现，避免 POST 回包
     被 generic localStorage 门禁吞掉。su_freq=0 沿用后台既有语义：关闭后永久不再弹。 */
  function initSignup(scope, sectionId){
    var sc = scope || document, el = null, matches = [];
    if(sectionId){
      document.querySelectorAll('.idg-su').forEach(function(node){
        if(node.getAttribute('data-section-id') === sectionId) matches.push(node);
      });
      el = matches.filter(function(node){ return !node.getAttribute('data-idgsu'); }).pop() || matches[matches.length - 1] || null;
      matches.filter(function(node){ return node !== el; }).forEach(function(old){
        if(old._idgSignupDestroy) old._idgSignupDestroy();
        if(old.hasAttribute('open') && typeof old.hide === 'function') old.hide();
        old.remove();
      });
    }else{
      el = (sc.classList && sc.classList.contains('idg-su')) ? sc : (sc.querySelector && sc.querySelector('.idg-su'));
    }
    if(!el || el.getAttribute('data-idgsu')) return;
    el.setAttribute('data-idgsu','1');

    var ID = el.id || 'Popup';
    var CAMP = el.getAttribute('data-idgsu-camp') || 'popup';
    var rawFreq = el.getAttribute('data-idgsu-freq');
    var FREQ = (rawFreq === null || rawFreq === '') ? 30 : parseInt(rawFreq, 10);
    var DELAY = parseInt(el.getAttribute('data-idgsu-delay') || '6', 10);
    if(isNaN(FREQ)) FREQ = 30;
    if(isNaN(DELAY) || DELAY < 0) DELAY = 6;
    var KEY = ID + ':' + CAMP;
    var PENDING_KEY = 'idg-signup-pending';
    var codeEl = el.querySelector('[data-idgsu-copy]');
    var CODE = codeEl ? codeEl.getAttribute('data-idgsu-copy') : '';
    var suppressed = false;

    try{
      var raw = window.localStorage.getItem(KEY);
      var legacy = window.localStorage.getItem(ID);
      if(!raw && legacy){
        raw = legacy;
        window.localStorage.setItem(KEY, legacy);
      }
      if(legacy) window.localStorage.removeItem(ID);
      if(raw){
        try{
          var t = Date.parse(JSON.parse(raw));
          if(isNaN(t)){
            window.localStorage.removeItem(KEY);
          }else if(FREQ > 0 && (Date.now() - t) > FREQ * 86400000){
            window.localStorage.removeItem(KEY);
          }else{
            suppressed = true;
          }
        }catch(parseError){
          /* 手改值、旧脚本或浏览器扩展都可能留下坏 JSON；坏 key 不能永久压死弹窗。 */
          window.localStorage.removeItem(KEY);
        }
      }
    }catch(e){}

    function seal(){
      if(DESIGN) return;
      try{ window.localStorage.setItem(KEY, JSON.stringify(new Date())); }catch(e){}
    }

    function emit(name, extra){
      if(DESIGN) return;
      var p = { popup_id: ID, campaign: CAMP, page_path: location.pathname };
      if(extra){ for(var k in extra){ p[k] = extra[k]; } }
      try{
        window.dataLayer = window.dataLayer || [];
        var d = { event: 'idg_' + name };
        for(var j in p){ d[j] = p[j]; }
        window.dataLayer.push(d);
      }catch(e){}
      try{
        if(window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish){
          var published = window.Shopify.analytics.publish('idg_' + name, p);
          if(published && typeof published.catch === 'function') published.catch(function(){});
        }
      }catch(e){}
      try{ document.dispatchEvent(new CustomEvent('idg:' + name, { detail: p })); }catch(e){}
    }

    var opened = false, viewed = false, restoreFocus = null, wrapper = null;
    var timers = [];
    var wrapperHadInert = false, wrapperAria = null;
    function lockBackground(){
      restoreFocus = document.activeElement;
      wrapper = document.getElementById('wrapper');
      if(!wrapper || wrapper.contains(el)) return;
      var panel = el.querySelector('[role="dialog"]');
      if(panel && typeof panel.focus === 'function'){
        try{ panel.focus({ preventScroll: true }); }catch(e){ panel.focus(); }
      }
      wrapperHadInert = wrapper.hasAttribute('inert');
      wrapperAria = wrapper.getAttribute('aria-hidden');
      wrapper.setAttribute('inert','');
      wrapper.setAttribute('aria-hidden','true');
    }
    function unlockBackground(){
      if(wrapper){
        if(!wrapperHadInert) wrapper.removeAttribute('inert');
        if(wrapperAria === null) wrapper.removeAttribute('aria-hidden');
        else wrapper.setAttribute('aria-hidden', wrapperAria);
      }
      wrapper = null;
      if(restoreFocus && restoreFocus !== document.body && restoreFocus.isConnected && typeof restoreFocus.focus === 'function'){
        try{ restoreFocus.focus({ preventScroll: true }); }catch(e){ restoreFocus.focus(); }
      }
      restoreFocus = null;
    }
    function watch(){
      var nowOpen = el.hasAttribute('open');
      if(nowOpen && !opened){
        opened = true;
        lockBackground();
        if(!viewed){ viewed = true; emit('popup_view'); }
      }else if(!nowOpen && opened){
        opened = false;
        unlockBackground();
        emit('popup_close');
        seal();
      }
    }
    watch();
    var mo = null;
    if(window.MutationObserver){
      mo = new MutationObserver(watch);
      mo.observe(el, { attributes: true, attributeFilter: ['open'] });
    }
    el._idgSignupDestroy = function(){
      if(mo) mo.disconnect();
      timers.forEach(function(timer){ window.clearTimeout(timer); });
      timers = [];
      unlockBackground();
    };

    el.addEventListener('keydown', function(e){
      if(e.key !== 'Tab' || !el.hasAttribute('open')) return;
      var focusable = Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(node){
        return !node.hidden && node.getClientRects().length > 0;
      });
      if(!focusable.length){ e.preventDefault(); el.querySelector('[role="dialog"]').focus(); return; }
      var first = focusable[0], last = focusable[focusable.length - 1];
      var panel = el.querySelector('[role="dialog"]');
      if(e.shiftKey && (document.activeElement === first || document.activeElement === panel)){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });

    var f = el.querySelector('.idg-su-form');
    if(f){
      f.addEventListener('submit', function(){
        try{ window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({ id: ID, at: Date.now() })); }catch(e){}
        emit('popup_submit');
      });
    }

    var success = !!el.querySelector('.idg-su-done');
    var error = !!el.querySelector('.idg-su-err');
    var pending = false;
    try{
      var pendingRaw = window.sessionStorage.getItem(PENDING_KEY);
      if(pendingRaw){
        try{
          var pendingData = JSON.parse(pendingRaw);
          pending = pendingData && pendingData.id === ID && (Date.now() - Number(pendingData.at || 0)) < 300000;
        }catch(parsePendingError){
          pending = false;
        }
        /* pending 只跨一次 customer form POST；无论回包状态如何都不留到下一次导航。 */
        window.sessionStorage.removeItem(PENDING_KEY);
      }
    }catch(e){}
    /* Safari 私密模式/企业策略可能禁用 sessionStorage。Shopify customer form 回包会
       回到自身 form id 的 hash；只在该 popup 自己的 success/error 上用它作降级归因。 */
    if(!pending && (success || error) && f && location.hash === '#' + f.id) pending = true;
    if(success && pending){ emit('popup_signup', { discount_code: CODE }); seal(); }

    if(codeEl){
      codeEl.addEventListener('click', function(){
        function copied(){
          codeEl.setAttribute('data-copied','1');
          var sp = codeEl.querySelector('span');
          if(sp) sp.textContent = codeEl.getAttribute('data-idgsu-copied') || 'COPIED';
          emit('popup_code_copy', { discount_code: CODE });
        }
        try{
          if(navigator.clipboard && navigator.clipboard.writeText){
            var writing = navigator.clipboard.writeText(CODE);
            if(writing && typeof writing.then === 'function') writing.then(copied).catch(function(){});
            else copied();
          }
        }catch(e){}
      });
    }

    var go = el.querySelector('[data-idgsu-go]');
    if(go){ go.addEventListener('click', function(){ emit('popup_cta_click', { discount_code: CODE }); seal(); }); }

    function visible(node){
      if(!node || node.hidden || !node.isConnected || !node.getClientRects().length) return false;
      var style = window.getComputedStyle(node);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }
    function otherOverlayOpen(){
      var modals = document.querySelectorAll('modal-dialog[open]');
      for(var i=0;i<modals.length;i++){ if(modals[i] !== el) return true; }
      if(document.querySelector('.side-panel.active,.mobile-toggle-wrapper.active')) return true;
      var privacy = document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,[id^="shopify-pc__"][role="dialog"]');
      for(var j=0;j<privacy.length;j++){ if(visible(privacy[j])) return true; }
      /* Privy campaign 4647269 目前仍在线上/预览自动触发。上线前应由店主停掉；
         这里至少在它已出现时延后 signup，避免主题弹窗再叠上去抢 body lock。 */
      var privy = document.querySelectorAll('#privy-widget .privy-widget-popup-outer-container,#privy-widget aside[class*="privy-widget-campaign-"]');
      for(var k=0;k<privy.length;k++){ if(visible(privy[k])) return true; }
      return document.body.classList.contains('open-cc') || (!el.hasAttribute('open') && document.body.classList.contains('overflow-hidden'));
    }
    function later(fn, ms){
      var timer = window.setTimeout(function(){
        timers = timers.filter(function(item){ return item !== timer; });
        fn();
      }, ms);
      timers.push(timer);
    }
    function scheduleShow(ms, force, focusTarget){
      function ready(){
        function attempt(remaining){
          if(!el.isConnected) return;
          if(!force){
            try{ if(window.localStorage.getItem(KEY)) return; }catch(e){}
          }
          /* 不与购物车、菜单、其它 modal 或隐私同意层抢 body lock。结果回包最多等
             5 分钟，普通营销弹窗等 60 秒；当前页仍繁忙就本次放弃。 */
          if(otherOverlayOpen()){
            if(remaining > 0) later(function(){ attempt(remaining - 1); }, 1000);
            return;
          }
          if(typeof el.show === 'function' && !el.hasAttribute('open')){
            el.show();
            if(focusTarget){
              later(function(){ if(focusTarget.isConnected) focusTarget.focus(); }, 140);
            }
          }
        }
        later(function(){ attempt(force ? 300 : 60); }, ms);
      }
      if(window.customElements && customElements.whenDefined) customElements.whenDefined('modal-dialog').then(ready);
      else ready();
    }
    if(pending && (success || error)) scheduleShow(0, true, error ? el.querySelector('.idg-su-input') : el.querySelector('.idg-su-done'));
    else if(!success && !error && !DESIGN && !suppressed) scheduleShow(DELAY * 1000, false, null);
  }

  function initAll(scope){
    initReveal(scope);
    var sc=scope||document;
    var mr = sc.id==='idg-modes' ? sc : sc.querySelector&&sc.querySelector('#idg-modes');
    initModes(mr);
    initFilm(scope);
    initFold(scope);
    initLib(scope);
    initSell(scope);
    initTech(scope);
    initStory(scope);
    initRail(scope);
    initSignup(scope);
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', function(){initAll()});
  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
    if(e.detail && e.detail.sectionId) initSignup(document, e.detail.sectionId);
  });
  document.addEventListener('shopify:section:unload', function(e){
    var sid = e.detail && e.detail.sectionId;
    if(!sid) return;
    document.querySelectorAll('.idg-su').forEach(function(el){
      if(el.getAttribute('data-section-id') !== sid) return;
      if(el._idgSignupDestroy) el._idgSignupDestroy();
      if(el.hasAttribute('open') && typeof el.hide === 'function') el.hide();
      el.remove();
    });
  });
})();
